import React from "react";
import flag_GB from 'svg-country-flags/svg/gb.svg'

const EnglandFlag = (props) => {
    return (
        <img {...props} src={flag_GB} />
    );
};

export default EnglandFlag;
